import { Box } from '@mui/material';
import {
  HeaderNavbar,
  SubscriptionGuard
} from 'modules';
import { Outlet } from 'react-router-dom';



export type MacroEconomicsLayoutProps = {};

export const MacroEconomicsLayout = (props: MacroEconomicsLayoutProps) => {
  return (
    <SubscriptionGuard.FC>
      <Box
        display='flex'
        flexDirection='column'
        paddingX='1.5rem'
      >
        <HeaderNavbar.FC />
        <Outlet />
      </Box>
    </SubscriptionGuard.FC>
  );
};
